import { useState, useEffect } from "react";
import "./TopBar.css";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

function TopBar() {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setHide(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`topbar ${hide ? "hide" : ""}`}>
      <div className="social">
        <FaFacebookF />
        <FaTwitter />
        <FaLinkedinIn />
        <FaYoutube />
      </div>

      <div className="phone">
        +91 8520823389
      </div>
    </div>
  );
}

export default TopBar;